import { FC, ReactNode } from 'react';

interface Props {
   children: ReactNode | Array<ReactNode>;
   useContainerQuery?: boolean;
   fullWidth?: boolean;
}

export const Container: FC<Props> = ({ children, useContainerQuery, fullWidth }) => (
   <div data-testid="container" className={`${!fullWidth ? 'container' : ''} ${useContainerQuery ? '@container' : ''}`}>
      {children}
   </div>
);
